import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=b6b0a554&scoped=true&"
import script from "./qr.vue?vue&type=script&lang=js&"
export * from "./qr.vue?vue&type=script&lang=js&"
import style0 from "./qr.vue?vue&type=style&index=0&id=b6b0a554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b0a554",
  null
  
)

export default component.exports